import debounce from 'lodash/debounce'
import delay from 'lodash/delay'
import throttle from 'lodash/throttle'
import { action, autorun, comparer, observable, reaction } from 'mobx'
import { useEffect } from 'react'

const pending = observable.set([], { deep: false })
export const isPaused = observable.box(false)
const DELAY = 500

export const allProps = observable({}, {}, { deep: false, name: 'allProps' })
export const isBusy = observable({}, {}, { name: 'isBusy' })
const processor = debounce(action(() => {
  for (const component of pending) {
    allProps[component.id] = component.mapping?.mapper?.toProps
    pending.delete(component)
  }
  updateBusy()
}), DELAY)

const updateBusy = action(() => {
  for (const k in isBusy) {
    isBusy[k] = false
  }
  for (const component of pending) {
    isBusy[component.id] = true
  }
})

const t_updateBusy = throttle(updateBusy, DELAY)

const effect = c => {
  pending.add(c)
  delay(() => t_updateBusy(), DELAY)
  if (!isPaused.get()) processor()
}

autorun(() => {
  processor()
})

export function useDebouncedProps (component) {
  useEffect(() =>
    reaction(
      () => component.mapping?.mapper?.toProps,
      () => effect(component),
      { equals: comparer.structural, name: 'debouncedProps', fireImmediately: true }), [])

  return [allProps[component.id], isBusy[component.id]]
}
